import React from "react";
import PropTypes from "prop-types";

const ProductHeader = ({
	product,
}) => {
	return (
		<h3 className="payment-product-label">
			{product.name}
		</h3>
	);
};

ProductHeader.propTypes = {
	product: PropTypes.object.isRequired,
};

export default ProductHeader;



// WEBPACK FOOTER //
// ./src/apps/payment/components/ProductHeader.jsx